<div class="datepicker-wrapper" #wrapper>
  <input
    class="lib-cm-input"
    [value]="displayValue"
    [placeholder]="placeholder"
    [disabled]="disabled"
    readonly
    (click)="open()"
    />
  <button
    type="button"
    class="cm-dt-toggle"
    (click)="open()"
    [disabled]="disabled"
    tabindex="-1"
    >
    <mat-icon>calendar_today</mat-icon>
  </button>
</div>

<ng-template #panel>
  <div class="cm-datetime-panel mat-elevation-z4">

    <mat-calendar
      [selected]="calendarSelected"
      (selectedChange)="onCalendarDateSelected($event)"
      [minDate]="minDateMoment"
    ></mat-calendar>

    <div class="cm-time-section">
      <div class="cm-time-inner">
        <div class="cm-time-col">
          <button type="button" mat-icon-button (click)="incrementHours()">
            <mat-icon>keyboard_arrow_up</mat-icon>
          </button>
          <span class="cm-time-val">{{ pad(hours) }}</span>
          <button type="button" mat-icon-button (click)="decrementHours()">
            <mat-icon>keyboard_arrow_down</mat-icon>
          </button>
        </div>

        <span class="cm-time-colon">:</span>

        <div class="cm-time-col">
          <button type="button" mat-icon-button (click)="incrementMinutes()">
            <mat-icon>keyboard_arrow_up</mat-icon>
          </button>
          <span class="cm-time-val">{{ pad(minutes) }}</span>
          <button type="button" mat-icon-button (click)="decrementMinutes()">
            <mat-icon>keyboard_arrow_down</mat-icon>
          </button>
        </div>

        @if (enableMeridian) {
          <button type="button" class="cm-ampm-btn" (click)="toggleAMPM()">
            {{ isPM ? 'PM' : 'AM' }}
          </button>
        }
      </div>
    </div>

    <div class="cm-actions">
      <button type="button" mat-icon-button (click)="confirm()">
        <mat-icon>check</mat-icon>
      </button>
    </div>

  </div>
</ng-template>
